<template>
    <div class="card">
        <div class="card-header">
            <div class="card-title">
                <span class="font-weight-bold" v-if="active == 1">Xem phiếu đăng ký học tập</span>
                <span class="font-weight-bold" v-if="active == 2">Hoàn tất phiếu đăng ký học tập</span>
                <span class="font-weight-bold" v-if="active == 3">Gửi phiếu đăng ký học tập</span>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <el-steps :active="active" align-center>
                        <el-step title="Tạo phiếu đăng ký học tập"></el-step>
                        <el-step title="Hoàn tất phiếu đăng ký học tập"></el-step>
                        <el-step title="Gửi phiếu đăng ký học tập"></el-step>
                    </el-steps>
                </div>
            </div>
            <div class="mt-6">
                <RegisterStudyForm
                    ref="formRef"
                    :errorsForm="errorsForm"
                    :is_show="true"
                    v-if="active === 1"
                    :contract_prop="contract"
                    @dataContract="dataContract"
                ></RegisterStudyForm>
                <CompletedStudyForm :contract="contract" :policy="policy" v-if="active === 2"></CompletedStudyForm>
                <CustomerConfirmForm :contract="contract" v-if="active === 3" :url_copy="url_copy"
                                     :url_confirm_contract="url_confirm_contract"></CustomerConfirmForm>
            </div>
        </div>
        <div class="card-header d-flex justify-content-end">
            <button class="btn btn-default mr-2" v-if="active > 1" @click="back">Quay lại</button>
            <button class="btn btn-success" v-if="active === 1" :disabled="is_loading_submit" @click="createStudy"><i
                v-if="is_loading_submit" class="el-icon-loading"></i>Xem tiếp
            </button>
            <button class="btn btn-success" v-if="active === 2" :disabled="is_loading_submit" @click="completedStudy"><i
                v-if="is_loading_submit" class="el-icon-loading"></i>Xem tiếp
            </button>
            <button class="btn btn-success" v-if="active === 3" :disabled="is_loading_submit" @click="confirmCustomer">
                <i
                    v-if="is_loading_submit" class="el-icon-loading"></i>Xác
                nhận
            </button>
        </div>
    </div>
</template>
<script>
import {mapGetters} from "vuex";

import Multiselect from "vue-multiselect";
import lodash from 'lodash-es';
import deepdash from 'deepdash-es';
import RegisterStudyForm from "@/views/pages/customer/components/RegisterStudyForm";
import CompletedStudyForm from "@/views/pages/customer/components/CompletedStudyForm";
import CustomerConfirmForm from "@/views/pages/customer/components/CustomerConfirmForm";
import {
    CONTRACT_ONLINE_GET_BY_ID, CONTRACT_ONLINE_GET_SHORT_LINK, UPDATE_PAYMENT_OPTION_BY_CONTRACT
} from "@/core/services/store/contract/contractOnline.module";
import {CUSTOMER_UPDATE_LEVEL} from "@/core/services/store/customer/customer.module";
import {LEVEL_3A} from "@/core/config/customer/customerOption";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {CAMBRIDGE, ECOACH, IELTS, TOEIC, ANU, IELTS_CAMBRIDGE, MENTER_ENGLISH_MASTERY} from "../../../core/config/center/centerOption";

const _ = deepdash(lodash);
export default {
    name: "ShowContractEdutalk",
    props: {},
    components: {
        CustomerConfirmForm,
        CompletedStudyForm,
        RegisterStudyForm,
        Multiselect
    },
    data() {
        return {
            errorsForm: {},
            active: 1,
            is_loading_submit: false,
            contract: {
                id: '',
                uuid: '',
                uuid_secret: '',
                is_confirm: 0,
                tuition_payment_id: '',
                is_older: true,
                name: '',
                phone: '',
                phone_other: '',
                email: '',
                birthday: '',
                center_id: '',
                branch_id: '',
                customer_id: this.$route.query.customer_id,
                total: '',
                total_need: '',
                total_promotions: '',
                courses: [
                    {
                        id: "",
                        name: "",
                        fee: 0
                    }
                ],
                list_promotions: [],
                parent: {
                    type: 'bo',
                    other_value: '',
                    name: '',
                    phone: '',
                    phone_other: '',
                }
            },
            url_copy: '',
            url_confirm_contract: '',
            policy: {}
        }
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Danh sách hợp đồng tư vấn"},
            {title: "Xem phiếu đăng ký học tập", icon: 'far fa-user'}
        ]);
        let id = this.$route.params.contract_id;
        this.getContractById(id);
    },
    methods: {
        dataContract(data) {
            this.contract = data;
        },
        hasPaymentMethod() {
            const form = this.$refs.formRef;
            const ids = this.contract?.method_payment_id || (form && form.method_payment_id);
            if (Array.isArray(ids)) {
                return ids.map(Number).some((id) => id > 0);
            }
            return Boolean(ids);
        },
        async createStudy() {
            const form = this.$refs.formRef;
            if (form && typeof form.prepareContractPayload === "function") {
                this.contract = form.prepareContractPayload();
            }

            // Nếu không chọn PTTT nào thì chỉ chuyển bước tiếp theo, không update
            if (!this.hasPaymentMethod()) {
                this.next();
                return;
            }

            this.is_loading_submit = true;
            try {
                const data = await this.$store.dispatch(UPDATE_PAYMENT_OPTION_BY_CONTRACT, {
                    contract_id: this.contract.id,
                    branch_id: this.contract.branch_id,
                    method_payment_id: this.contract.method_payment_id,
                    payment_option: this.contract.payment_option,
                    payment_amount: (this.contract.payment_amount !== "" && this.contract.payment_amount != null)
                        ? Number(this.contract.payment_amount)
                        : 0,
                    installments_number: this.contract.installments_number,
                    is_sacombank: this.contract.is_sacombank ? 1 : 0,
                    installment_bank: this.contract.installment_bank,
                    installment_months: this.contract.installment_months,
                });
                if (data && data.data) {
                    this.contract.payment_options = data.data;
                    if (data.data.payment_method) {
                        this.contract.payment_option = data.data.payment_method;
                    }
                }
                this.$message.success(data?.message || "Đã lưu thông tin thanh toán");
                this.next();
                this.changeLink();
            } catch (e) {
                this.$message.error({
                    message: e?.data?.message || "Lưu thông tin thanh toán thất bại",
                    duration: 10000,
                    showClose: true,
                });
            } finally {
                this.is_loading_submit = false;
            }
        },
        changeLink() {
            let path_url_copy = `/xac-thuc?code=${this.contract.uuid}`;
            let path_url_confirm_contract = `/xac-thuc?code=${this.contract.uuid}&check=${this.contract.uuid_secret}`;
            let domain = '';
            switch (this.contract.center_id) {
                case ECOACH:
                    domain = `${process.env.VUE_APP_BASE_URL_ECOACH}`;
                    break;
                case IELTS:
                case CAMBRIDGE:
                case MENTER_ENGLISH_MASTERY:
                    domain = `${process.env.VUE_APP_BASE_URL_IELTS}`;
                    break;
                case TOEIC:
                    domain = `${process.env.VUE_APP_BASE_URL_TOEIC_MASTER}`;
                    break;
                case IELTS_CAMBRIDGE:
                    domain = `${process.env.VUE_APP_BASE_URL_IELTS}`;
                    break;
                case ANU:
                    domain = `${process.env.VUE_APP_BASE_URL_ANU}`;
                    break;

            }
            this.url_copy = this.getShortLinkUrlCopy(domain + path_url_copy);
            this.url_confirm_contract = this.getShortLinkConfirm(domain + path_url_confirm_contract);
        },
        getShortLinkUrlCopy(url) {
            this.$store.dispatch(CONTRACT_ONLINE_GET_SHORT_LINK, {
                url: url,
                center_id: this.contract.center_id
            }).then((data) => {
                this.url_copy = data.data;
            });
        },
        getShortLinkConfirm(url) {
            this.$store.dispatch(CONTRACT_ONLINE_GET_SHORT_LINK, {
                url: url,
                center_id: this.contract.center_id
            }).then((data) => {
                this.url_confirm_contract = data.data;
            });
        },
        completedStudy() {
            this.next();
        },
        confirmCustomer() {
            this.$store.dispatch(CUSTOMER_UPDATE_LEVEL, {
                customer_id: this.contract.customer_id,
                level: LEVEL_3A
            }).then(() => {
                this.$message.success('Xác nhận thành công');
                this.$router.push({
                    name: "contract-index"
                })
            }).catch((e) => {
                this.$message.error(e.data.message);
            })
        },
        next() {
            this.changeLink();
            if (this.active++ > 2) this.active = 1;
        },
        back() {
            if (this.active-- === 0) this.active = 1;
            if (this.contract.id) {
                this.getContractById(this.contract.id);
            }
        },
        getContractById(id) {
            this.$store.dispatch(CONTRACT_ONLINE_GET_BY_ID, id).then((data) => {
                this.contract = data.data;
                this.policy = data.data.policy ?? null;
                this.changeLink();
            })
        },
    },
    computed: {
        ...mapGetters(['currentUser'])
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.withdraw-course {
    position: absolute;
    right: 20px;
    top: 37px;
}
</style>
